import { methodPut, methodGet, methodPost, methodDelete, methodPatch } from './methods';

import { API_INFO } from '../constants';

export const getLimitedDeliveries = async (query) => {
  return methodGet(API_INFO + `transport/province-limited-deliveries/`, query);
};
